// @flow strict
import React from 'react';
import { withPrefix, Link } from 'gatsby';
import styles from './Author.module.scss';

type Props = {
    author: {
        name: string,
        bio: string,
        photo: string
    },
    size: number,
};

const Profile = ({ author, size }: Props) => (
    <Link
        to="/"
        className={`${styles['author__photo']} profile`}
        style={{
            width: `${size}px`,
            height: `${size}px`,
        }}
    >
        <img
            src={withPrefix(author.photo)}
            className={styles['author__photo-img']}
            data-size={size}
            alt={author.name}
        />
    </Link>
);

export default Profile;
